import React, { useState } from 'react';
import { Box, Paper, Typography, TextField } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';
import { CustomTextArea } from '../../../../common/CustomTextArea';

export default function OtherDetails({ keyPath }) {
  const dispatch = useDispatch();
  const otherDetails = useSelector((state) =>
    getNestedState(state.andrologyReducer, keyPath),
  );

  const handleChange = (key, value) => {
    dispatch(setAndrologyData(`${keyPath}.${key}`, value));
  };

  return (
    <Box flex={1}>
      <Paper className="p-3 mb-3">
        <Typography variant="h6" gutterBottom>
          Other Details
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
        <label>Interpretation</label>
          <CustomTextArea
            value={otherDetails.interpretation}
            onChange={(e) => handleChange('interpretation', e.target.value)}
            name="interpretation"
            minRows={2}
            maxRows={10}
          />
 <label>Comments</label>
          <CustomTextArea
            value={otherDetails.comments}
            onChange={(e) => handleChange('comments', e.target.value)}
            name="interpretation"
          />
           <label>Embryologist</label>
          <TextField
            // label="Embryologist"
            name="embryologist"
            variant="outlined"
            fullWidth
            value={otherDetails.embryologist}
            onChange={(e) => handleChange('embryologist', e.target.value)}
          />
        </Box>
      </Paper>
    </Box>
  );
}
